module.exports = __webpack_public_path__ + "static/media/07.d9d81c23.png";